import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';

import env from '@/env';

export const getClientPartner = async (): Promise<string> => {
  const fetchResponse = await fetch(`${env.VITE_API_URL}/pb/s/api/sqo-portal/users/me/partner`, {
    method: 'GET',
    headers: {
      authenticate: localStorage.getItem('accessToken') || '',
    },
  });

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as string;
  return response;
};
